import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import titleMixin from "@/mixins/titleMixin";

import vueFeather from "vue-feather";
import CKEditor from "@ckeditor/ckeditor5-vue";
import VueApexCharts from "vue3-apexcharts";

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import { aliases, mdi } from 'vuetify/iconsets/mdi'
import {  fa } from 'vuetify/iconsets/fa'
import '@mdi/font/css/materialdesignicons.css' 
import '@fortawesome/fontawesome-free/css/all.css'

import 'vuetify/dist/vuetify.min.css'

// Importa el componente v-treeview
import { VTreeview } from 'vuetify/labs/VTreeview'

import "bootstrap";
import "@/assets/css/font-awesome.css";
import "@/assets/css/linearicon.css";
import "@/assets/css/vendors/font-awesome.css";
import "./assets/scss/app.scss";

const vuetify = createVuetify({
  components: {
    ...components,
    VTreeview // Agrega el componente VTreeview a la lista de componentes
  },
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
        mdi,
        fa
    }
  },
})

require('@/store/subscriber')


window.axios = require('axios');
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
};
window.CancelToken = axios.CancelToken;
window.cancel

store.dispatch('attempt', localStorage.getItem('token')).then(() => {
    const app = createApp(App);
    app.use(CKEditor);

    app.use(vuetify);

    app.component("vueFeather", vueFeather);
    app.component("apexchart", VueApexCharts);
    app.mixin(titleMixin);
    app.use(router);
    app.use(store);
    app.mount("#app");
})
